import {Item, ItemRarity} from '../../../generated/types';
import {getItemSubTitle, getItemWeight} from '../../../components/render-helpers';
import {humanNumber, uppercaseFirstLetter} from '../../../components/utils';
import {composeDescription, stripMarkup} from '../../../lib/seo/text';
import type {OgCardData} from '../../../lib/seo/site';

export function isMagicItem(item: Item): boolean {
	return !!item.rarity && item.rarity !== ItemRarity.None && item.rarity !== ItemRarity.Unknown;
}

/** «магический предмет» или «предмет» — для заголовка */
export function itemKind(item: Item): string {
	return isMagicItem(item) ? 'магический предмет' : 'предмет';
}

/** Цена хранится в медных монетах — как в карточке предмета */
function humanPrice(priceInCc: number): string {
	if (priceInCc > 100) return `${humanNumber(priceInCc / 100)} ЗМ`;
	if (priceInCc > 10) return `${humanNumber(priceInCc / 10)} СМ`;
	return `${humanNumber(priceInCc)} ММ`;
}

/** Подзаголовок карточки («Чудесный предмет, необычный (требует Настроенности)») без разметки */
export function itemSubtitle(item: Item): string {
	return stripMarkup(getItemSubTitle(item));
}

export function itemDescription(item: Item): string {
	const subtitle = itemSubtitle(item);
	const parts = [`${uppercaseFirstLetter(itemKind(item))} ${item.title}${subtitle ? `: ${subtitle}` : ''}.`];
	if (item.price) parts.push(`Цена ${humanPrice(item.price)}.`);
	if (item.weight) parts.push(`Вес ${getItemWeight(item.weight)}.`);
	return composeDescription(parts.join(' '), item.description);
}

export function itemOgCard(item: Item): OgCardData {
	return {
		label: uppercaseFirstLetter(itemKind(item)),
		title: item.title,
		originalTitle: item.originalTitle,
		subtitle: itemSubtitle(item),
	};
}
